import React from 'react';
import { DEFAULT_ICON_SIZE } from '../../constants';
import type { GoIconProps } from '../../types';

const GoSpinnerIcon = ({ size = DEFAULT_ICON_SIZE, color = 'currentColor' }: GoIconProps) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8 3C10.7614 3 13 5.23844 13 7.9997C13 9.12545 12.6279 10.1643 12 11"
            stroke={color}
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <animateTransform
                attributeName="transform"
                dur="0.8s"
                from="0 8 8"
                repeatCount="indefinite"
                to="360 8 8"
                type="rotate"
            />
        </path>
    </svg>
);
GoSpinnerIcon.id = 'GoSpinnerIcon';
GoSpinnerIcon.displayName = 'GoSpinnerIcon';
export default GoSpinnerIcon;
